import { render, staticRenderFns } from "./SteamCard.vue?vue&type=template&id=12b3d694&"
import script from "./SteamCard.vue?vue&type=script&lang=js&"
export * from "./SteamCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports